import styled from 'styled-components'

export const AboutSection = styled.div`
    height: 500px;
    background: url('../images/creative/about-bg.jpg');
    background-size: cover;
    background-position: center;
    background-attachment: fixed
`
export const Aboutinfo = styled.div`

    padding-top: 100px;
    width: 50%;
    float: right;
`
export const Infotitle = styled.h2`
    font-weight: bold;
    font-size: 50px;
    margin: 10px 0;
`

export const Span = styled.span`
    font-weight: normal;
`
export const Infodir = styled.h4`
    font-size: 40px;
    color: #eb5424;
    margin-top:10px;
    margin-bottom: 20px;
`
export const Infodesc = styled.p`
    color: #000;
    margin-bottom: 15px;
    line-height: 1.8
`
export const Anchor = styled.a`
    text-decoration: none
`
